export default __webpack_public_path__ + "3379895209bc182310c17621707a82ea.png";